import React from "react";
import { connect } from "react-redux";
import { updateRouteState } from "./actions/actionRoute";
import BaseDetailView from "./components/BaseDetailView";
import BaseListView from "./components/BaseListView";
import CampaignDetails from "./components/CampaignDetails";
import CampaignList from "./components/CampaignList";
import Dashboard from "./components/Dashboard";
import EditEmail from "./components/EditEmail";
import Integrations from "./components/Integrations";
import Leads from "./components/Leads";
import Template1 from "./components/subscription/template1/Template1";
import PricingPlan from "./PricingPlan";

const Routes = (props) => {

    const components = {
        BaseListView : BaseListView,
        BaseDetailView: BaseDetailView,
        CampaignList: CampaignList,
        Template1: Template1,
        Leads: Leads,
        CampaignDetails: CampaignDetails,
        Dashboard: Dashboard,
        EditEmail: EditEmail,
        Integrations: Integrations,
        PricingPlan: PricingPlan,
    }

    let RenderedComponent = components[props.route.link];

  return (
      <RenderedComponent />
  )
};

const mapStateToProps = (state) => ({
    route: state.route,
  });
  
  const mapDispatchToProps = (dispatch) => ({
    handleUpdateRouteState: (params) => dispatch(updateRouteState(params)),
  });


  export default connect(mapStateToProps, mapDispatchToProps)(Routes);